import jsonPointer from 'json-pointer';
import isPlainObject from 'lodash/isPlainObject';

function descend(value) {
  return isPlainObject(value) && Object.keys(value).length > 0;
}

export default function getDict(values, allowUndefinedRoot = true) {
  if (values == null) {
    // eslint-disable-next-line no-void
    return allowUndefinedRoot ? { '': void 0 } : {}; // empty dictionary
  }

  if (!isPlainObject(values)) {
    return { '': values }; // root value
  }

  return jsonPointer.dict(values, descend);
}
